import { render, staticRenderFns } from "./SchedulerSettings.vue?vue&type=template&id=3c8991f1&scoped=true&"
import script from "./SchedulerSettings.vue?vue&type=script&lang=ts&"
export * from "./SchedulerSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8991f1",
  null
  
)

export default component.exports